import { useEffect, useRef } from "react";
import { Outlet } from "react-router";
import styled, { css } from "styled-components";
import { useContentHeight } from "commons/layers/store/layerHook";
import { useLeft, useSecList, useTopSelected } from "store/modules/navigates/navigatesHook";
import Header from "./Header";
import Nav from "./Nav";
import Footer from "./Footer";
import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import ProfileNotice from "./ProfileNotice";

const LayoutWrap = styled.div`
  * {
    font-family: "Pretendard", NotoSansKR, Helvetica, Arial, sans-serif;
  }
`;
const Container = styled.div<{ active: boolean }>`
  position: relative;
  height: auto;
  min-height: 100%;
  padding-top: 56px;
  padding-left: ${props => (props.active ? "300px" : "60px")};
  /* -webkit-transition: all 0.1s;
  transition: all 0.1s; */
`;

const Content = styled.article`
  width: 100%;
  min-height: calc(100vh - 70px);
  min-width: 1024px;
  padding: 25px 40px 80px;
  position: relative;
  overflow-x: hidden;
  /* font-family: NotoSansKR, Helvetica, Arial, sans-serif; */

  & > section:first-child {
    margin-top: 0;
  }
`;

function Layout(): JSX.Element {
  const getTopSelected = useTopSelected();
  const sTop = getTopSelected();
  const sec = useSecList(sTop);
  const { isLeft } = useLeft();
  const { set } = useContentHeight();
  const contentRef = useRef<HTMLElement>(null);
  useEffect(() => {
    set(() => {
      return contentRef.current?.getBoundingClientRect() as DOMRect;
    });
  }, [contentRef]);

  return (
    <LayoutWrap>
      <Header />
      <ProfileNotice />

      <Container active={sec && isLeft ? true : false}>
        <Nav />
        <Content ref={contentRef}>
          <Outlet />
        </Content>
      </Container>
      <Footer active={sec && isLeft ? true : false} />
    </LayoutWrap>
  );
}

/*
 * 채널톡 실행
 */
ChannelService.loadScript();
ChannelService.boot({
  pluginKey: "1ded3e92-ed36-470f-8f70-25470d930546",
});

export default Layout;
